"use strict";

var _toConsumableArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _toArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var URI = require("uri-js");

var uuid = require("uuid");

var E = require("../expressions");

var C = require("../util/Consts");

var Err = require("../util/Errors");

var Helpers_1 = require("./Helpers");

var index_1 = require("./index"); // ----------------------------------------------------------------------------
// Functional forms
// ----------------------------------------------------------------------------


function _bound(_ref) {
  var args = _ref.args,
      mapping = _ref.mapping;
  var variable = args[0];

  if (variable.expressionType !== E.ExpressionType.Variable) {
    throw new Err.InvalidArgumentTypes(args, C.SpecialOperator.BOUND);
  }

  var val = mapping.has(variable.name) && !!mapping.get(variable.name);
  return Helpers_1.bool(val);
} // BOUND ----------------------------------------------------------------------


var bound = {
  arity: 1,
  applyAsync: function () {
    var _applyAsync = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(_ref2) {
      var args, mapping;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              args = _ref2.args, mapping = _ref2.mapping;
              return _context.abrupt("return", _bound({
                args: args,
                mapping: mapping
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function applyAsync(_x) {
      return _applyAsync.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref3) {
    var args = _ref3.args,
        mapping = _ref3.mapping;
    return _bound({
      args: args,
      mapping: mapping
    });
  }
}; // IF -------------------------------------------------------------------------

var ifSPARQL = {
  arity: 3,
  applyAsync: function () {
    var _applyAsync2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(_ref4) {
      var args, mapping, evaluate, valFirst, ebv;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              args = _ref4.args, mapping = _ref4.mapping, evaluate = _ref4.evaluate;
              _context2.next = 3;
              return evaluate(args[0], mapping);

            case 3:
              valFirst = _context2.sent;
              ebv = valFirst.coerceEBV();
              return _context2.abrupt("return", ebv ? evaluate(args[1], mapping) : evaluate(args[2], mapping));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function applyAsync(_x2) {
      return _applyAsync2.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref5) {
    var args = _ref5.args,
        mapping = _ref5.mapping,
        evaluate = _ref5.evaluate;
    var valFirst = evaluate(args[0], mapping);
    var ebv = valFirst.coerceEBV();
    return ebv ? evaluate(args[1], mapping) : evaluate(args[2], mapping);
  }
}; // COALESCE -------------------------------------------------------------------

var coalesce = {
  arity: Infinity,
  applyAsync: function () {
    var _applyAsync3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(_ref6) {
      var args, mapping, evaluate, errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, expr;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              args = _ref6.args, mapping = _ref6.mapping, evaluate = _ref6.evaluate;
              errors = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context3.prev = 5;
              _iterator = args[Symbol.iterator]();

            case 7:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context3.next = 21;
                break;
              }

              expr = _step.value;
              _context3.prev = 9;
              _context3.next = 12;
              return evaluate(expr, mapping);

            case 12:
              return _context3.abrupt("return", _context3.sent);

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](9);
              errors.push(_context3.t0);

            case 18:
              _iteratorNormalCompletion = true;
              _context3.next = 7;
              break;

            case 21:
              _context3.next = 27;
              break;

            case 23:
              _context3.prev = 23;
              _context3.t1 = _context3["catch"](5);
              _didIteratorError = true;
              _iteratorError = _context3.t1;

            case 27:
              _context3.prev = 27;
              _context3.prev = 28;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 30:
              _context3.prev = 30;

              if (!_didIteratorError) {
                _context3.next = 33;
                break;
              }

              throw _iteratorError;

            case 33:
              return _context3.finish(30);

            case 34:
              return _context3.finish(27);

            case 35:
              throw new Err.CoalesceError(errors);

            case 36:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[5, 23, 27, 35], [9, 15], [28,, 30, 34]]);
    }));

    function applyAsync(_x3) {
      return _applyAsync3.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref7) {
    var args = _ref7.args,
        mapping = _ref7.mapping,
        evaluate = _ref7.evaluate;
    var errors = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = args[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var expr = _step2.value;

        try {
          return evaluate(expr, mapping);
        } catch (err) {
          errors.push(err);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    throw new Err.CoalesceError(errors);
  }
}; // logical-or (||) ------------------------------------------------------------
// https://www.w3.org/TR/sparql11-query/#func-logical-or

var logicalOr = {
  arity: 2,
  applyAsync: function () {
    var _applyAsync4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(_ref8) {
      var args, mapping, evaluate, _args4, leftExpr, rightExpr, leftTerm, left, rightTerm, right, _rightTerm, _right;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              args = _ref8.args, mapping = _ref8.mapping, evaluate = _ref8.evaluate;
              _args4 = _slicedToArray(args, 2), leftExpr = _args4[0], rightExpr = _args4[1];
              _context4.prev = 2;
              _context4.next = 5;
              return evaluate(leftExpr, mapping);

            case 5:
              leftTerm = _context4.sent;
              left = leftTerm.coerceEBV();

              if (!left) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", Helpers_1.bool(true));

            case 9:
              _context4.next = 11;
              return evaluate(rightExpr, mapping);

            case 11:
              rightTerm = _context4.sent;
              right = rightTerm.coerceEBV();
              return _context4.abrupt("return", Helpers_1.bool(right));

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](2);
              _context4.next = 20;
              return evaluate(rightExpr, mapping);

            case 20:
              _rightTerm = _context4.sent;
              _right = _rightTerm.coerceEBV();

              if (_right) {
                _context4.next = 24;
                break;
              }

              throw _context4.t0;

            case 24:
              return _context4.abrupt("return", Helpers_1.bool(true));

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 16]]);
    }));

    function applyAsync(_x4) {
      return _applyAsync4.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref9) {
    var args = _ref9.args,
        mapping = _ref9.mapping,
        evaluate = _ref9.evaluate;

    var _args6 = _slicedToArray(args, 2),
        leftExpr = _args6[0],
        rightExpr = _args6[1];

    try {
      var leftTerm = evaluate(leftExpr, mapping);
      var left = leftTerm.coerceEBV();

      if (left) {
        return Helpers_1.bool(true);
      }

      var rightTerm = evaluate(rightExpr, mapping);
      var right = rightTerm.coerceEBV();
      return Helpers_1.bool(right);
    } catch (leftErr) {
      var _rightTerm2 = evaluate(rightExpr, mapping);

      var _right2 = _rightTerm2.coerceEBV();

      if (!_right2) {
        throw leftErr;
      }

      return Helpers_1.bool(true);
    }
  }
}; // logical-and (&&) -----------------------------------------------------------
// https://www.w3.org/TR/sparql11-query/#func-logical-and

var logicalAnd = {
  arity: 2,
  applyAsync: function () {
    var _applyAsync5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(_ref10) {
      var args, mapping, evaluate, _args7, leftExpr, rightExpr, leftTerm, left, rightTerm, right, _rightTerm3, _right3;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              args = _ref10.args, mapping = _ref10.mapping, evaluate = _ref10.evaluate;
              _args7 = _slicedToArray(args, 2), leftExpr = _args7[0], rightExpr = _args7[1];
              _context5.prev = 2;
              _context5.next = 5;
              return evaluate(leftExpr, mapping);

            case 5:
              leftTerm = _context5.sent;
              left = leftTerm.coerceEBV();

              if (left) {
                _context5.next = 9;
                break;
              }

              return _context5.abrupt("return", Helpers_1.bool(false));

            case 9:
              _context5.next = 11;
              return evaluate(rightExpr, mapping);

            case 11:
              rightTerm = _context5.sent;
              right = rightTerm.coerceEBV();
              return _context5.abrupt("return", Helpers_1.bool(right));

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](2);
              _context5.next = 20;
              return evaluate(rightExpr, mapping);

            case 20:
              _rightTerm3 = _context5.sent;
              _right3 = _rightTerm3.coerceEBV();

              if (!_right3) {
                _context5.next = 24;
                break;
              }

              throw _context5.t0;

            case 24:
              return _context5.abrupt("return", Helpers_1.bool(false));

            case 25:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 16]]);
    }));

    function applyAsync(_x5) {
      return _applyAsync5.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref11) {
    var args = _ref11.args,
        mapping = _ref11.mapping,
        evaluate = _ref11.evaluate;

    var _args9 = _slicedToArray(args, 2),
        leftExpr = _args9[0],
        rightExpr = _args9[1];

    try {
      var leftTerm = evaluate(leftExpr, mapping);
      var left = leftTerm.coerceEBV();

      if (!left) {
        return Helpers_1.bool(false);
      }

      var rightTerm = evaluate(rightExpr, mapping);
      var right = rightTerm.coerceEBV();
      return Helpers_1.bool(right);
    } catch (leftErr) {
      var _rightTerm4 = evaluate(rightExpr, mapping);

      var _right4 = _rightTerm4.coerceEBV();

      if (_right4) {
        throw leftErr;
      }

      return Helpers_1.bool(false);
    }
  }
}; // sameTerm -------------------------------------------------------------------

var sameTerm = {
  arity: 2,
  applyAsync: function () {
    var _applyAsync6 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(_ref12) {
      var args, mapping, evaluate, _args$map, _args$map2, leftExpr, rightExpr, left, right;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              args = _ref12.args, mapping = _ref12.mapping, evaluate = _ref12.evaluate;
              _args$map = args.map(function (a) {
                return evaluate(a, mapping);
              }), _args$map2 = _slicedToArray(_args$map, 2), leftExpr = _args$map2[0], rightExpr = _args$map2[1];
              _context6.next = 4;
              return leftExpr;

            case 4:
              left = _context6.sent;
              _context6.next = 7;
              return rightExpr;

            case 7:
              right = _context6.sent;
              return _context6.abrupt("return", Helpers_1.bool(left.toRDF().equals(right.toRDF())));

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function applyAsync(_x6) {
      return _applyAsync6.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref13) {
    var args = _ref13.args,
        mapping = _ref13.mapping,
        evaluate = _ref13.evaluate;

    var _args$map3 = args.map(function (a) {
      return evaluate(a, mapping);
    }),
        _args$map4 = _slicedToArray(_args$map3, 2),
        left = _args$map4[0],
        right = _args$map4[1];

    return Helpers_1.bool(left.toRDF().equals(right.toRDF()));
  }
}; // IN -------------------------------------------------------------------------

var inSPARQL = {
  arity: Infinity,
  checkArity: function checkArity(args) {
    return args.length >= 1;
  },
  applyAsync: function () {
    var _applyAsync7 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7(_ref14) {
      var args, mapping, evaluate, context, _args11, leftExpr, remaining, left;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              args = _ref14.args, mapping = _ref14.mapping, evaluate = _ref14.evaluate, context = _ref14.context;
              _args11 = _toArray(args), leftExpr = _args11[0], remaining = _args11.slice(1);
              _context7.next = 4;
              return evaluate(leftExpr, mapping);

            case 4:
              left = _context7.sent;
              return _context7.abrupt("return", inRecursiveAsync(left, {
                args: remaining,
                mapping: mapping,
                evaluate: evaluate,
                context: context
              }, []));

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function applyAsync(_x7) {
      return _applyAsync7.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref15) {
    var args = _ref15.args,
        mapping = _ref15.mapping,
        evaluate = _ref15.evaluate,
        context = _ref15.context;

    var _args13 = _toArray(args),
        leftExpr = _args13[0],
        remaining = _args13.slice(1);

    var left = evaluate(leftExpr, mapping);
    return inRecursiveSync(left, {
      args: remaining,
      mapping: mapping,
      evaluate: evaluate,
      context: context
    }, []);
  }
};

function inRecursiveAsync(_x8, _x9, _x10) {
  return _inRecursiveAsync.apply(this, arguments);
}

function _inRecursiveAsync() {
  _inRecursiveAsync = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee15(needle, _ref16, results) {
    var args, mapping, evaluate, context, noErrors, next, isEqual;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            args = _ref16.args, mapping = _ref16.mapping, evaluate = _ref16.evaluate, context = _ref16.context;

            if (!(args.length === 0)) {
              _context15.next = 4;
              break;
            }

            noErrors = results.every(function (v) {
              return !v;
            });
            return _context15.abrupt("return", noErrors ? Helpers_1.bool(false) : Promise.reject(new Err.InError(results)));

          case 4:
            _context15.prev = 4;
            _context15.next = 7;
            return evaluate(args.shift(), mapping);

          case 7:
            next = _context15.sent;
            isEqual = index_1.regularFunctions.get(C.RegularOperator.EQUAL);

            if (!(isEqual.apply([needle, next]).typedValue === true)) {
              _context15.next = 13;
              break;
            }

            return _context15.abrupt("return", Helpers_1.bool(true));

          case 13:
            return _context15.abrupt("return", inRecursiveAsync(needle, {
              args: args,
              mapping: mapping,
              evaluate: evaluate,
              context: context
            }, [].concat(_toConsumableArray(results), [false])));

          case 14:
            _context15.next = 19;
            break;

          case 16:
            _context15.prev = 16;
            _context15.t0 = _context15["catch"](4);
            return _context15.abrupt("return", inRecursiveAsync(needle, {
              args: args,
              mapping: mapping,
              evaluate: evaluate,
              context: context
            }, [].concat(_toConsumableArray(results), [_context15.t0])));

          case 19:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[4, 16]]);
  }));
  return _inRecursiveAsync.apply(this, arguments);
}

function inRecursiveSync(needle, _ref17, results) {
  var args = _ref17.args,
      mapping = _ref17.mapping,
      evaluate = _ref17.evaluate,
      context = _ref17.context;

  if (args.length === 0) {
    var noErrors = results.every(function (v) {
      return !v;
    });

    if (noErrors) {
      Helpers_1.bool(false);
    } else {
      throw new Err.InError(results);
    }
  }

  try {
    var next = evaluate(args.shift(), mapping);
    var isEqual = index_1.regularFunctions.get(C.RegularOperator.EQUAL);

    if (isEqual.apply([needle, next]).typedValue === true) {
      return Helpers_1.bool(true);
    } else {
      return inRecursiveSync(needle, {
        args: args,
        mapping: mapping,
        evaluate: evaluate,
        context: context
      }, [].concat(_toConsumableArray(results), [false]));
    }
  } catch (err) {
    return inRecursiveSync(needle, {
      args: args,
      mapping: mapping,
      evaluate: evaluate,
      context: context
    }, [].concat(_toConsumableArray(results), [err]));
  }
} // NOT IN ---------------------------------------------------------------------


var notInSPARQL = {
  arity: Infinity,
  checkArity: function checkArity(args) {
    return args.length >= 1;
  },
  applyAsync: function () {
    var _applyAsync8 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8(context) {
      var _in, isIn;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _in = index_1.specialFunctions.get(C.SpecialOperator.IN);
              _context8.next = 3;
              return _in.applyAsync(context);

            case 3:
              isIn = _context8.sent;
              return _context8.abrupt("return", Helpers_1.bool(!isIn.typedValue));

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function applyAsync(_x11) {
      return _applyAsync8.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(context) {
    var _in = index_1.specialFunctions.get(C.SpecialOperator.IN);

    var isIn = _in.applySync(context);

    return Helpers_1.bool(!isIn.typedValue);
  }
}; // ----------------------------------------------------------------------------
// Annoying functions
// ----------------------------------------------------------------------------
// CONCAT

var concat = {
  arity: Infinity,
  applyAsync: function () {
    var _applyAsync9 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11(_ref18) {
      var args, evaluate, mapping, pLits, lits, strings, joined, lang;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              args = _ref18.args, evaluate = _ref18.evaluate, mapping = _ref18.mapping;
              pLits = args.map(
              /*#__PURE__*/
              function () {
                var _ref19 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee9(expr) {
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          return _context9.abrupt("return", evaluate(expr, mapping));

                        case 1:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));

                return function (_x13) {
                  return _ref19.apply(this, arguments);
                };
              }()).map(
              /*#__PURE__*/
              function () {
                var _ref20 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee10(pTerm) {
                  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _context10.t0 = Helpers_1;
                          _context10.next = 3;
                          return pTerm;

                        case 3:
                          _context10.t1 = _context10.sent;
                          _context10.t2 = ['string', 'langString'];
                          _context10.t3 = args;
                          _context10.t4 = C.SpecialOperator.CONCAT;
                          return _context10.abrupt("return", _context10.t0.typeCheckLit.call(_context10.t0, _context10.t1, _context10.t2, _context10.t3, _context10.t4));

                        case 8:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                }));

                return function (_x14) {
                  return _ref20.apply(this, arguments);
                };
              }());
              _context11.next = 4;
              return Promise.all(pLits);

            case 4:
              lits = _context11.sent;
              strings = lits.map(function (lit) {
                return lit.typedValue;
              });
              joined = strings.join('');
              lang = langAllEqual(lits) ? lits[0].language : undefined;
              return _context11.abrupt("return", lang ? Helpers_1.langString(joined, lang) : Helpers_1.string(joined));

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function applyAsync(_x12) {
      return _applyAsync9.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref21) {
    var args = _ref21.args,
        evaluate = _ref21.evaluate,
        mapping = _ref21.mapping;
    var lits = args.map(function (expr) {
      return evaluate(expr, mapping);
    }).map(function (pTerm) {
      return Helpers_1.typeCheckLit(pTerm, ['string', 'langString'], args, C.SpecialOperator.CONCAT);
    });
    var strings = lits.map(function (lit) {
      return lit.typedValue;
    });
    var joined = strings.join('');
    var lang = langAllEqual(lits) ? lits[0].language : undefined;
    return lang ? Helpers_1.langString(joined, lang) : Helpers_1.string(joined);
  }
};

function langAllEqual(lits) {
  return lits.length > 0 && lits.every(function (lit) {
    return lit.language === lits[0].language;
  });
} // ----------------------------------------------------------------------------
// Context dependant functions
// ----------------------------------------------------------------------------


var now = {
  arity: 0,
  applyAsync: function () {
    var _applyAsync10 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee12(_ref22) {
      var context;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              context = _ref22.context;
              return _context12.abrupt("return", new E.DateTimeLiteral(context.now, context.now.toUTCString()));

            case 2:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function applyAsync(_x15) {
      return _applyAsync10.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref23) {
    var context = _ref23.context;
    return new E.DateTimeLiteral(context.now, context.now.toUTCString());
  }
}; // https://www.w3.org/TR/sparql11-query/#func-iri

var IRI = {
  arity: 1,
  applyAsync: function () {
    var _applyAsync11 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee13(_ref24) {
      var args, evaluate, mapping, context, input;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              args = _ref24.args, evaluate = _ref24.evaluate, mapping = _ref24.mapping, context = _ref24.context;
              _context13.next = 3;
              return evaluate(args[0], mapping);

            case 3:
              input = _context13.sent;
              return _context13.abrupt("return", IRI_(input, context.baseIRI, args));

            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function applyAsync(_x16) {
      return _applyAsync11.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref25) {
    var args = _ref25.args,
        evaluate = _ref25.evaluate,
        mapping = _ref25.mapping,
        context = _ref25.context;
    var input = evaluate(args[0], mapping);
    return IRI_(input, context.baseIRI, args);
  }
};

function IRI_(input, baseIRI, args) {
  var lit = input.termType !== 'namedNode' ? Helpers_1.typeCheckLit(input, ['string'], args, C.SpecialOperator.IRI) : input;
  var iri = URI.resolve(baseIRI || '', lit.str());
  return new E.NamedNode(iri);
} // https://www.w3.org/TR/sparql11-query/#func-bnode
// id has to be distinct over all id's in dataset


var BNODE = {
  arity: Infinity,
  checkArity: function checkArity(args) {
    return args.length === 0 || args.length === 1;
  },
  applyAsync: function () {
    var _applyAsync12 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee14(_ref26) {
      var args, evaluate, mapping, context, input, strInput, bnode;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              args = _ref26.args, evaluate = _ref26.evaluate, mapping = _ref26.mapping, context = _ref26.context;

              if (!(args.length === 1)) {
                _context14.next = 7;
                break;
              }

              _context14.next = 4;
              return evaluate(args[0], mapping);

            case 4:
              _context14.t0 = _context14.sent;
              _context14.next = 8;
              break;

            case 7:
              _context14.t0 = undefined;

            case 8:
              input = _context14.t0;
              strInput = input ? Helpers_1.typeCheckLit(input, ['string'], args, C.SpecialOperator.BNODE).str() : undefined;

              if (!context.bnode) {
                _context14.next = 15;
                break;
              }

              _context14.next = 13;
              return context.bnode(strInput);

            case 13:
              bnode = _context14.sent;
              return _context14.abrupt("return", new E.BlankNode(bnode.value));

            case 15:
              return _context14.abrupt("return", BNODE_(strInput));

            case 16:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function applyAsync(_x17) {
      return _applyAsync12.apply(this, arguments);
    }

    return applyAsync;
  }(),
  applySync: function applySync(_ref27) {
    var args = _ref27.args,
        evaluate = _ref27.evaluate,
        mapping = _ref27.mapping,
        context = _ref27.context;
    var input = args.length === 1 ? evaluate(args[0], mapping) : undefined;
    var strInput = input ? Helpers_1.typeCheckLit(input, ['string'], args, C.SpecialOperator.BNODE).str() : undefined;

    if (context.bnode) {
      var bnode = context.bnode(strInput);
      return new E.BlankNode(bnode.value);
    }

    return BNODE_(strInput);
  }
};

function BNODE_(input) {
  return new E.BlankNode('blank_' + uuid.v4());
}

var _specialDefinitions = {
  // --------------------------------------------------------------------------
  // Functional Forms
  // https://www.w3.org/TR/sparql11-query/#func-forms
  // --------------------------------------------------------------------------
  'bound': bound,
  'if': ifSPARQL,
  'coalesce': coalesce,
  '&&': logicalAnd,
  '||': logicalOr,
  'sameterm': sameTerm,
  'in': inSPARQL,
  'notin': notInSPARQL,
  // Annoying functions
  'concat': concat,
  // Context dependent functions
  'now': now,
  'iri': IRI,
  'uri': IRI,
  'BNODE': BNODE
};
exports.specialDefinitions = immutable_1.Map(_specialDefinitions);